const DEFAULT_OPTIONS = [10, 50, 100];

export default function RowsPerPageSelect({ value, onChange, options = DEFAULT_OPTIONS, style }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      style={{
        fontSize: 12.5, padding: '4px 8px', borderRadius: 7,
        border: '1.5px solid var(--border)', background: 'var(--card)',
        color: 'var(--text)', fontFamily: 'inherit', height: 32,
        fontWeight: 500, cursor: 'pointer',
        ...style,
      }}
    >
      {options.map((n) => (
        <option key={n} value={n}>{n} / page</option>
      ))}
    </select>
  );
}
